<script lang="ts">import { icon, iconActive, iconHover } from "./colors";
export let size = 17;
export let active = false;
export let hover = false;
export let color = undefined;
let width = size;
let height = Math.floor(1.1 * width);
let fill = color ? color : active ? iconActive : hover ? iconHover : icon;
$: fill = color ? color : active ? iconActive : hover ? iconHover : icon;
</script>

<svg
	{height}
	{width}
	viewBox="0 0 17 18"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	class="icon"
>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M3.91134 3.70805H9.21447C10.719 3.70805 11.5841 4.21984 12.3364 5.24464C12.4863 5.48307 12.5 8 12.5 8C12.5 8 13.45 8.3873 13.5 8C13.5782 7.39447 13.5782 4.25476 13.5782 4.25476C12.9387 3.91396 12.5248 3.2649 12.5248 2.54839C12.5248 1.42244 13.5026 0.5 14.7432 0.5C16.0222 0.5 17 1.42123 17 2.54839C17 3.2649 16.586 3.91396 15.9465 4.25476V11.9016C15.9465 12.482 15.4198 12.9938 14.7432 12.9938H14.6304C14.028 12.9938 13.5769 13.4032 13.5769 13.95V15.9634C13.5769 16.8172 12.7875 17.5 11.8839 17.5H1.65449C0.752283 17.5 0 16.8172 0 15.9634V7.2593C0 4.76656 1.16624 3.70805 3.91134 3.70805ZM3.42176 6.57651H10.1538C10.7562 6.57651 11.2444 7.01965 11.2444 7.60009V11.0141C11.2444 11.5608 10.7549 12.0039 10.1538 12.0039H3.42176C2.78225 12.0039 2.294 11.5608 2.294 11.0141V7.60009C2.294 7.01965 2.78225 6.57651 3.42176 6.57651Z"
		{fill}
	/>
</svg>

<style>
	.icon {
    margin: 0px
}
</style>
